import { useRef } from "react";
import type { ChangeEvent } from "react";
import { X } from "lucide-react";
import { cn } from "@/lib/utils";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface MediaInputProps {
  id: string;
  label: string;
  value: string;
  onChange: (value: string) => void;
  accept: string;
}

export function MediaInput({ id, label, value, onChange, accept }: MediaInputProps) {
  const fileInputRef = useRef<HTMLInputElement>(null);

  const handleFileChange = (e: ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const url = URL.createObjectURL(file);
      onChange(url);
    }
  };

  const isLocal = value.startsWith("blob:");

  return (
    <div className="field-stack">
      <div className="flex items-center justify-between">
        <Label htmlFor={id} className="cursor-pointer">
          {label}
        </Label>
        <button
          type="button"
          className="text-[10px] font-bold uppercase text-primary transition-opacity hover:opacity-80"
          onClick={() => fileInputRef.current?.click()}
        >
          {isLocal ? "Change File" : "Upload Local"}
        </button>
      </div>
      <div className="relative">
        <Input
          id={id}
          placeholder="Paste URL or upload file..."
          className={cn("studio-input pr-10", isLocal && "border-primary/50 text-primary")}
          value={isLocal ? "Local file selected" : value}
          readOnly={isLocal}
          onChange={(e) => onChange(e.target.value)}
        />
        {(isLocal || value) && (
          <button
            type="button"
            className="absolute right-3 top-1/2 -translate-y-1/2 text-muted-foreground hover:text-destructive transition-colors"
            onClick={() => onChange("")}
          >
            <X className="size-4" />
          </button>
        )}
        <input
          type="file"
          ref={fileInputRef}
          className="hidden"
          accept={accept}
          onChange={handleFileChange}
        />
      </div>
    </div>
  );
}
